import { useTranslation } from 'react-i18next';
import { Text } from './text';
import { Flex } from '@react-css/flex';
import { colors } from '../../style/color';

export const LabelRequired = ({
  children,
  notRequired,
  description,
  descriptionProps,
  className,
  style,
  htmlFor,
}) => {
  const { t } = useTranslation();

  const title = (
    <Text fontSize="large" fontWeight="bolder">{children}</Text>
  );

  return (
    <div className={className} style={style}>
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        style={{ marginTop: ".8rem", width: "92%", marginBottom: ".3rem" }}
      >
        {htmlFor ? (
          <label htmlFor={htmlFor} style={{ flex: 1, cursor: 'pointer' }}>
            {title}
          </label>
        ) : (
          title
        )}
        {!notRequired && <Text fontWeight="bold" style={{ color: colors.secondary }}>{t('Required')}</Text>}
      </Flex>
      {description ? (
        <Text fontSize="x-small" {...(descriptionProps ?? {})}>{description}</Text>
      ) : null}
    </div>
  );
};
